import { render } from "./AboutProduct.vue?vue&type=template&id=53ccb4f3"
import script from "./AboutProduct.vue?vue&type=script&lang=js"
export * from "./AboutProduct.vue?vue&type=script&lang=js"

import "./AboutProduct.vue?vue&type=style&index=0&id=53ccb4f3&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__